<mat-form-field appearance="fill">
  <input matInput placeholder="Rename simulation" [(ngModel)]="data" />
</mat-form-field>
